export default __webpack_public_path__ + "static/media/powertools-logo-name.abca291b.svg";